import type { ElectricVehicle, Vehicle } from '../../types';
import isBEV from './isBEV';
import isPHEV from './isPHEV';

const isElectricVehicle = (vehicle: Vehicle): vehicle is ElectricVehicle => {
  return isBEV(vehicle) || isPHEV(vehicle);
};

export default isElectricVehicle;
